class KrasisResearchIndex extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('[data-research-track]');
    this.nextButton = this.querySelector('[data-research-next]');
    this.progressButtons = Array.from(
      this.querySelectorAll('[data-research-progress]')
    );

    this.updateFrame = null;

    this.handleNext = () => this.scrollByCard(1);

    this.handleProgressClick = (event) => {
      const index = Number(event.currentTarget.dataset.researchProgress);

      if (Number.isNaN(index)) return;

      this.scrollToProgress(index);
    };

    this.queueStateUpdate = () => {
      if (this.updateFrame !== null) return;

      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.updateControls();
      });
    };
  }

  connectedCallback() {
    if (
      !this.track ||
      !this.nextButton ||
      this.dataset.initialized === 'true'
    ) {
      return;
    }

    this.dataset.initialized = 'true';

    this.nextButton.addEventListener('click', this.handleNext);

    this.progressButtons.forEach((button) => {
      button.addEventListener('click', this.handleProgressClick);
    });

    this.track.addEventListener('scroll', this.queueStateUpdate, {
      passive: true,
    });

    window.addEventListener('resize', this.queueStateUpdate, {
      passive: true,
    });

    this.updateControls();
  }

  disconnectedCallback() {
    this.nextButton?.removeEventListener('click', this.handleNext);

    this.progressButtons.forEach((button) => {
      button.removeEventListener('click', this.handleProgressClick);
    });

    this.track?.removeEventListener('scroll', this.queueStateUpdate);
    window.removeEventListener('resize', this.queueStateUpdate);

    if (this.updateFrame !== null) {
      cancelAnimationFrame(this.updateFrame);
    }

    this.updateFrame = null;
    delete this.dataset.initialized;
  }

  getScrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
  }

  scrollByCard(direction) {
    const item = this.track?.querySelector(
      '.krasis-home-research__item'
    );

    if (!item) return;

    const styles = getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);
    const distance = item.offsetWidth + gap;

    this.track.scrollBy({
      left: direction * distance,
      behavior: this.getScrollBehavior(),
    });
  }

  scrollToProgress(index) {
    if (!this.track || this.progressButtons.length < 2) return;

    const end = Math.max(
      0,
      this.track.scrollWidth - this.track.clientWidth
    );

    const finalIndex = this.progressButtons.length - 1;
    const progress = Math.min(1, Math.max(0, index / finalIndex));

    this.track.scrollTo({
      left: end * progress,
      behavior: this.getScrollBehavior(),
    });
  }

  updateControls() {
    if (!this.track || !this.nextButton) return;

    const end = Math.max(
      0,
      this.track.scrollWidth - this.track.clientWidth
    );

    const scrollLeft = Math.min(
      end,
      Math.max(0, this.track.scrollLeft)
    );

    const progress = end > 0 ? scrollLeft / end : 0;

    const activeIndex =
      this.progressButtons.length > 1
        ? Math.round(progress * (this.progressButtons.length - 1))
        : 0;

    this.progressButtons.forEach((button, index) => {
      if (index === activeIndex) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    this.nextButton.disabled =
      end <= 2 || scrollLeft >= end - 2;
  }
}

if (!customElements.get('krasis-research-index')) {
  customElements.define(
    'krasis-research-index',
    KrasisResearchIndex
  );
}
